import * as Yup from 'yup';
import { RoleIdUserEnum } from '~/utils/enum';
import regex from '~/utils/regex';

const userValidation = (t: (key: string) => string) => ({
  resetPassword: Yup.object().shape({
    password: Yup.string().required(t('validation.password')),
  }),
  edit: Yup.object().shape({
    username: Yup.string().required(t('validation.username_empty')),
    name: Yup.string()
      .required(t('validation.name'))
      .matches(/^[^0-9]*$/, t('validation.name_is_valid')),
    email: Yup.string().required(t('validation.email')).matches(regex.email, t('validation.email_is_valid')),
    phone: Yup.string()
      .required(t('validation.phone'))
      .matches(/^\d+$/, t('validation.phone_digits_only'))
      .length(10, t('validation.phone_max_length'))
      .matches(/^0/, t('validation.phone_start_zero')),
    address: Yup.string().required(t('validation.address')),
    roleid: Yup.number().required(t('validation.roleid')),
    province_id: Yup.string().when('roleid', (roleid: any, schema) => {
      const requiredRoles = [
        RoleIdUserEnum.NGUOI_DEO,
        RoleIdUserEnum.TINH_THANH,
        RoleIdUserEnum.QUAN_TRI,
        RoleIdUserEnum.XA_PHUONG,
      ];
      const isRequired = roleid != null && requiredRoles.includes(Number(roleid));
      return isRequired ? schema.required(t('validation.province_id')) : schema.notRequired();
    }),
    ward_id: Yup.string().when(['province_id', 'roleid'], ([province_id, roleid], schema) => {
      const id = Array.isArray(roleid) ? roleid[0] : roleid;

      if (id === String(RoleIdUserEnum.TRUNG_UONG)) return schema.notRequired();

      const isRequired = province_id && id !== RoleIdUserEnum.TINH_THANH;

      return isRequired ? schema.required(t('validation.ward_id')) : schema.notRequired();
    }),
  }),
});

export default userValidation;
